module.exports = __webpack_public_path__ + "static/robert-5c8fdc65b101782b75c3e86bd2be9a4a.png";